import pulbicApi from '../utils/publicApi';

export const login = (config = {}) => {
	const { data, options } = config;
	return pulbicApi({
		url: `api/auth/login`,
		method: "POST",
		data,
		...options,
	});
}

export const refreshToken = (config = {}) => {
	const { data, options } = config;
	return pulbicApi({
		url: `api/auth/refresh-token`,
		method: "POST",
		data,
		...options,
	});
}